<template>

    <div class="main">

        <professor v-if="$store.state.user.tipo == 2"></professor>
        <escola v-else></escola>

    </div>

</template>
<script>

import escola from '@/components/home/escola'
import smed from '@/components/home/smed'
import professor from '@/components/home/professor'

export default {
    data () {
      return {
        text: ''
      }
    },
    methods:{
        load(){  }
    },
    components:{ escola, smed, professor }
}
</script>
